import { css, cx } from 'core/emotion';
import useViewModel from './viewModel';
import { FormValues } from '../viewModel';
import { useMainView } from 'settings';
import { useLayoutEffect, useRef, useState } from 'react';
import { getScrollbarWidth } from 'core/scroll';
import {
  MatchFooter,
  DataModelFooterImperativeHandle,
} from '@nuvo-importer/common';

const FormFooter = ({
  onBackClick,
  isShowFieldRequired,
  values,
  isModalClose,
  onIsAvailableCollapseChange,
  onIsShowChange,
}: {
  onBackClick: () => void;
  isShowFieldRequired: boolean;
  values: FormValues;
  isModalClose: boolean;
  onIsAvailableCollapseChange: (isAvailableCollapse: boolean) => void;
  onIsShowChange: (isShow: boolean) => void;
}) => {
  const { requiredDataModels, matchedDataModels } = useViewModel({ values });
  const { modal } = useMainView();
  const wrapperClassName = cx(
    'match-form-footer bottom-0 left-0 right-0 z-20',
    modal ? 'absolute' : 'fixed'
  );

  const [rightPositionForScrollbar, setRightPositionForScrollbar] = useState(0);
  const matchFooterRef = useRef<DataModelFooterImperativeHandle>(null);

  useLayoutEffect(() => {
    const isAvailableCollapse =
      matchFooterRef.current?.getIsAvailableCollapse();

    if (isShowFieldRequired && !isModalClose && isAvailableCollapse) {
      matchFooterRef.current?.setIsShowBadge(true);
    }
    // eslint-disable-next-line
  }, [isShowFieldRequired, isModalClose]);

  useLayoutEffect(() => {
    const scrollBarWidth = getScrollbarWidth();
    if (modal) {
      return;
    }
    if (isModalClose) {
      setRightPositionForScrollbar(scrollBarWidth);
    } else {
      setRightPositionForScrollbar(0);
    }
  }, [modal, isModalClose]);

  return (
    <MatchFooter
      dataModels={requiredDataModels}
      isShowFieldRequired={isShowFieldRequired}
      matchedDataModels={matchedDataModels}
      onIsAvailableCollapseChange={onIsAvailableCollapseChange}
      buttonWrapperClassName={css`
        padding-right: ${rightPositionForScrollbar}px;
      `}
      className={
        modal
          ? css`
              padding-top: 90px;
            `
          : css`
              padding-top: 55px;
            `
      }
      onBackClick={onBackClick}
      wrapperClassName={wrapperClassName}
      onIsShowChange={onIsShowChange}
      ref={matchFooterRef}
    />
  );
};

export default FormFooter;
